import styled from 'styled-components';
import { blackSphera, greenSp, neutralBlueGray } from 'src/utilities/UIStyles/variables/Colors';

export const SignupContainer = styled.section`
  display: flex;
  margin-bottom: 5%;
`;

export const SignupInfo = styled.div`
  width: 50%;
  padding: 10% 0 0 5%;
  > form {
    > button {
      background-color: ${greenSp};
      color: ${blackSphera};
      padding: 1% 3%;
      margin: 2%;
      border-style: none;
      border-radius: 5px;
      width: 45%;
      font-size: 1.2vw;
    }
    > p {
      margin-bottom: 5%;
      color: ${neutralBlueGray};
    }
  }
  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    line-height: 50px;
    width: 82%;
    margin-bottom: 20%;
    > span {
      color: ${greenSp};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      line-height: 30px;
    }
    > form {
      > button {
        padding: 2% 0;
        width: 45%;
        font-size: 1.2vw;
      }
    }
  }
  @media (max-width: 600px) {
    width: 100%;
    padding: 25% 0 5% 5%;
    > h2 {
      font-size: 7vw;
      line-height: 40px;
      width: 95%;
      margin-bottom: 2.5%;
    }
    > form {
      > button {
        background-color: ${greenSp};
        color: ${blackSphera};
        padding: 3%;
        margin: 2%;
        border-style: none;
        border-radius: 5px;
        width: 45%;
        font-size: 1.8vw;
      }
    }
  }
`;

export const SignupForm = styled.div`
  display: flex;
  width: 60%;
  height: 60%;
  > img {
    width: 90%;
    height: auto;
    padding: 10% 0 5% 0;
    margin: 0 0 0 10%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > img {
      width: 90%;
      height: auto;
      margin: 0 0 0 10%;
    }
  }
`;
